import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const AddPaq2 = ({styles, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Paquete nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Código</label>
                  <Form.Input autoComplete="off" name="codigoPaquete" id="codigoPaquete" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoPaquete'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrPaquete" id="descrPaquete" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrPaquete'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddPaq2
